import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NonConformanceReportConcernOrigin } from "@enums/nonConformanceReportConcernOrigin.enum";
import { NonConformanceReportStatus } from "@enums/nonConformanceReportStatus.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Client } from "@interfaces/models/client.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { Part } from "@interfaces/models/part.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { ClientService } from "@services/client.service";
import { ExportLogService } from "@services/exportLog.service";
import { NonConformanceReportService } from "@services/nonConformanceReport.service";
import { PartService } from "@services/part.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "nonConformanceReports",
	styleUrls: ["nonConformanceReports.css"],
	templateUrl: "nonConformanceReports.html"
})
export class NonConformanceReportsAdminComponent {
	canExportGrid = false;
	clients: Client[] =[];
	concernOrigins: any;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "Non Conformance Report";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	parts: Part[] = [];
	people: UserProfile[] = [];
	statuses: any;
	title: string;
	
	constructor(private router: Router, private toastService: ToastService, private exportLogService: ExportLogService, private itemService: NonConformanceReportService, private partService: PartService, private protectedGridService: ProtectedGridService, private userProfileService: UserProfileService, private clientService: ClientService) {
		this.concernOrigins = GetPropertiesFromEnum(NonConformanceReportConcernOrigin);
		this.statuses = GetPropertiesFromEnum(NonConformanceReportStatus);
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.title = `${this.itemType}s`;
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getItems();
		this.getParts();
		this.getPeople();
		this.getClients();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Non Conformance Reports")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if(result)
		{
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.getItems();
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}_edit`]);
	}

	getClients() {
		this.clientService.getAll()
			.subscribe(
				(res: any) => this.clients = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getItems() {
		this.itemService.getGrid()
			.subscribe(
				(res: any) => this.items = res.response,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getParts() {
		this.partService.getAll()
			.subscribe(
				(res: any) => this.parts = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}
	
	getPeople() {
		this.userProfileService.getAllWithUsers()
			.subscribe(
				(res: any) =>  {
					this.people = res.response;
					this.people.sort((a,b) => a.fullName.localeCompare(b.fullName));
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	isEditEnabledForRow(e: any) {
		return e.row.data.status !== NonConformanceReportStatus.Closed;
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Non Conformance Reports";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}`]);
	}
}